/**
 * Check if the type of window is not undefined, then we're in a browser environment.
 */
export const isBrowser = () => typeof window !== 'undefined';
